import { LocalDate } from "@js-joda/core";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ResponseOf } from "../../../../../core/api";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

type CaregiverTasksResponse = ResponseOf<"get", "./caregivers/:caregiverId/tasks">;

export function useCaregiverAssignedTasks(
  caregiverId: CaregiverProfileCaregiver["id"],
  from: LocalDate | null,
  to: LocalDate | null
) {
  const { api } = useApi();

  return useQuery({
    queryKey: [
      "caregiverProfileModal",
      caregiverId,
      "assignedTasks",
      from?.toString() ?? "all",
      to?.toString() ?? "all",
    ],
    queryFn: () =>
      api.get("./caregivers/:caregiverId/tasks", {
        path: { caregiverId },
        query: from !== null && to !== null ? { from, to } : {},
      }),
    placeholderData: keepPreviousData,
  });
}

export type CaregiverAssignedTask = CaregiverTasksResponse["caregiverTaskInstances"][number];
